// src/pages/BoardPackConfiguration.jsx
import BoardPackConfigurationPage from '@/components/BoardPackConfiguration/BoardPackConfigurationPage'
import React from 'react'

const BoardPackConfiguration = () => {
  return (
   <BoardPackConfigurationPage/>
  )
}

export default BoardPackConfiguration